// import { NavLink } from "react-router-dom";
import JobZImage from "../../../common/jobz-img";
// import { publicUser } from "../../../../globals/route-names";
import { loadScript } from "../../../../globals/constants";
// import SectionPagination from "../../public-user/sections/common/section-pagination";
import { useEffect } from "react";
import axiosInstance from '../../../../axiosInstance';
import { API_URL } from "../../../../config";
import { useState } from "react";
import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";

// var componentConfig = {
//     postUrl: 'upload.php'
// };
function CanCVManagerPage() {
    const { t } = useTranslation();
    const [fileName, setFileName] = useState("");
    const [file, setFile] = useState(null);
    const [loading, setLoading] = useState(false);
    const [result, setResult] = useState(null);

    const handleFileChange = (event) => {
        const selectedFile = event.target.files[0];
        if (selectedFile) {
            setFileName(selectedFile.name);
            setFile(selectedFile);
        }
    };

    const handleScan = async () => {
        if (!file) return;
        setLoading(true);
        try {
            const formData = new FormData();
            formData.append("cv", file);

            const res = await axiosInstance.post(`${API_URL}/cv-scanner`, formData, {
                headers: { "Content-Type": "multipart/form-data" },
            });

            setResult(res.data.data);
        } catch (error) {
            console.error("CV Scan Failed:", error.response?.data || error.message);
            alert("Something went wrong while scanning CV.");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        loadScript("js/custom.js");
    }, []);

    return (
        <>
            <Helmet>
                <title>CV checker | CV Diffusion</title>
                <meta name="description" content="Welcome to the home page of MyApp." />
            </Helmet>
            <div
                className="d-flex flex-column flex-md-row justify-content-center align-items-start p-4"
                style={{ minHeight: "100vh", backgroundColor: "#f8f9fa", gap: "20px" }}
            >
                {/* Left Box - Upload */}
                <div
                    className="d-flex flex-column align-items-center p-5 bg-white shadow rounded upload-box"
                    style={{
                        width: "400px", maxWidth: "100%", flexShrink: 0
                    }}
                >
                    <h4 className="text-secondary">{t("My CVs")}</h4>

                    {/* <a href={cvFile.url} target="_blank" rel="noopener noreferrer" className="text-green-600">
                            {cvFile.name}
                        </a> */}

                    <p className="text-secondary">{fileName || `${t("NO CVS UPLOADED YET")}`}</p>


                    {/* {cvFile ? (
                        <a href={cvFile.url} target="_blank" rel="noopener noreferrer" className="text-green-600">
                            {cvFile.name}
                        </a>
                    ) : (
                        <p className="text-secondary">{fileName || "NO CVS UPLOADED YET"}</p>
                    )} */}
                    {/* Upload Box */}
                    <div
                        className="d-flex flex-column align-items-center justify-content-center"
                        style={{
                            height: "100px",
                            width: "90%",
                            maxWidth: "360px",  
                            border: "2px dashed black",
                            borderRadius: "6px",
                            cursor: "pointer",
                        }}
                        onClick={() => document.getElementById("fileUpload").click()}
                    >
                        <p className="text-secondary mb-0 p-4 text-center">{t("Drop your file here, or upload one from your device.")}</p>
                        {/* <p className="text-secondary mb-0">{t("device")}</p> */}
                        <input
                            type="file"
                            id="fileUpload"
                            accept="application/pdf"
                            onChange={handleFileChange}
                            className="d-none"
                        />
                    </div>

                    {/* Scan Button */}
                    <div style={{ cursor: fileName ? "pointer" : "not-allowed" }}>
                        <button
                            className="mt-3 btn btn-primary"
                            style={{
                                width: "200px",
                                height: "49px",
                                borderRadius: "8px",
                                opacity: fileName ? 1 : 0.5,
                            }}
                            disabled={!fileName || loading}
                            onClick={handleScan}
                        >
                            {loading ? "Scanning..." : "Scan CV"}
                        </button>
                    </div>

                    {/* Gemini Note */}
                    <div style={{ display: "flex", alignItems: "center", marginTop: "7px" }}>
                        <p style={{ margin: 0 }}>
                            {t("We use")}{" "}
                            <span style={{ width: "60px", display: "inline-block" }}>
                                <JobZImage src="images/Google_Gemini_logo.png" />
                            </span>{" "}
                            {t("to scan your CV.")}

                        </p>
                    </div>
                </div>

                {/* Right Box - Result */}
                <div
                    className="d-flex align-items-center justify-content-center bg-white shadow rounded result-box"
                    style={{
                        width: "100%",
                        maxWidth: "800px",
                        minHeight: "368px",
                        padding: "30px",
                        textAlign: "center",
                        boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)"
                    }}
                >
                    {result ? (
                        <div
                            className="accordion w-100"
                            id="cvAccordion"
                            style={{
                                overflowY: "auto",
                                height: "100%",
                                paddingRight: "10px",
                                textAlign: "left"
                            }}
                        >
                            {/* CV Score */}
                            <div className="accordion-item">
                                <h2 className="accordion-header" id="headingScore">
                                    <button
                                        className="accordion-button"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#collapseScore"
                                        aria-expanded="true"
                                        aria-controls="collapseScore"
                                    >
                                        {t("CV Score")}: {result.cv_score}/100
                                    </button>
                                </h2>
                                <div
                                    id="collapseScore"
                                    className="accordion-collapse collapse show"
                                    aria-labelledby="headingScore"
                                    data-bs-parent="#cvAccordion"
                                >
                                    <div className="accordion-body">Overall CV Score.</div>
                                </div>
                            </div>

                            {/* Format */}
                            <div className="accordion-item">
                                <h2 className="accordion-header" id="headingFormat">
                                    <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#collapseFormat"
                                        aria-expanded="false"
                                        aria-controls="collapseFormat"
                                    >
                                        Format<div style={{ backgroundColor: 'red', borderRadius: '5px', marginLeft: '5px', padding: '3px', color: 'white' }}>
                                            {result.ai_response.suggestions.format.format_score}
                                        </div>
                                    </button>
                                </h2>
                                <div
                                    id="collapseFormat"
                                    className="accordion-collapse collapse"
                                    aria-labelledby="headingFormat"
                                    data-bs-parent="#cvAccordion"
                                >
                                    <p><strong>Description:</strong></p>
                                    <div className="p-3 bg-white rounded border mb-3">
                                        {result.ai_response.suggestions.format.description}
                                    </div>

                                    <p><strong>Suggestion:</strong></p>
                                    <div className="p-3 bg-white rounded border">
                                        {Array.isArray(result.ai_response.suggestions.format.suggestion)
                                            ? (
                                                <ul className="mb-0">
                                                    {result.ai_response.suggestions.format.suggestion.map((item, index) => (
                                                        <li key={index}>{item}</li>
                                                    ))}
                                                </ul>
                                            ) : (
                                                <p className="mb-0">{result.ai_response.suggestions.format.suggestion}</p>
                                            )}
                                    </div>
                                </div>
                            </div>

                            {/* Sections */}
                            <div className="accordion-item">
                                <h2 className="accordion-header" id="headingSections">
                                    <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#collapseSections"
                                        aria-expanded="false"
                                        aria-controls="collapseSections"
                                    >
                                        Sections<div style={{ backgroundColor: 'red', borderRadius: '5px', marginLeft: '5px', padding: '3px', color: 'white' }}>
                                            {result.ai_response.suggestions.sections.sections_score}
                                        </div>
                                    </button>
                                </h2>
                                <div
                                    id="collapseSections"
                                    className="accordion-collapse collapse"
                                    aria-labelledby="headingSections"
                                    data-bs-parent="#cvAccordion"
                                >
                                    <p><strong>Description:</strong></p>
                                    <div className="p-3 bg-white rounded border mb-3">
                                        {result.ai_response.suggestions.sections.description}
                                    </div>

                                    <p><strong>Suggestion:</strong></p>
                                    <div className="p-3 bg-white rounded border">
                                        {Array.isArray(result.ai_response.suggestions.sections.suggestion)
                                            ? (
                                                <ul className="mb-0">
                                                    {result.ai_response.suggestions.sections.suggestion.map((item, index) => (
                                                        <li key={index}>{item}</li>
                                                    ))}
                                                </ul>
                                            ) : (
                                                <p className="mb-0">{result.ai_response.suggestions.sections.suggestion}</p>
                                            )}
                                    </div>
                                </div>
                            </div>

                            {/* Content */}
                            <div className="accordion-item">
                                <h2 className="accordion-header" id="headingContent">
                                    <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#collapseContent"
                                        aria-expanded="false"
                                        aria-controls="collapseContent"
                                    >
                                        Content<div style={{ backgroundColor: 'red', borderRadius: '5px', marginLeft: '5px', padding: '3px', color: 'white' }}>
                                            {result.ai_response.suggestions.content.content_score}
                                        </div>
                                    </button>
                                </h2>
                                <div
                                    id="collapseContent"
                                    className="accordion-collapse collapse"
                                    aria-labelledby="headingContent"
                                    data-bs-parent="#cvAccordion"
                                >
                                    <p><strong>Description:</strong></p>
                                    <div className="p-3 bg-white rounded border mb-3">
                                        {result.ai_response.suggestions.content.description}
                                    </div>

                                    <p><strong>Suggestion:</strong></p>
                                    <div className="p-3 bg-white rounded border">
                                        {Array.isArray(result.ai_response.suggestions.content.suggestion)
                                            ? (
                                                <ul className="mb-0">
                                                    {result.ai_response.suggestions.content.suggestion.map((item, index) => (
                                                        <li key={index}>{item}</li>
                                                    ))}
                                                </ul>
                                            ) : (
                                                <p className="mb-0">{result.ai_response.suggestions.content.suggestion}</p>
                                            )}
                                    </div>
                                </div>
                            </div>

                            {/* Style */}
                            <div className="accordion-item">
                                <h2 className="accordion-header" id="headingStyle">
                                    <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#collapseStyle"
                                        aria-expanded="false"
                                        aria-controls="collapseStyle"
                                    >
                                        Style<div style={{ backgroundColor: 'red', borderRadius: '5px', marginLeft: '5px', padding: '3px', color: 'white' }}>
                                            {result.ai_response.suggestions.style.style_score}
                                        </div>
                                    </button>
                                </h2>
                                <div
                                    id="collapseStyle"
                                    className="accordion-collapse collapse"
                                    aria-labelledby="headingStyle"
                                    data-bs-parent="#cvAccordion"
                                >
                                    <p><strong>Description:</strong></p>
                                    <div className="p-3 bg-white rounded border mb-2">
                                        {result.ai_response.suggestions.style.description}
                                    </div>
                                    <p><strong>Suggestion:</strong></p>
                                    <div className="p-2 bg-white rounded border mb-3">
                                        {Array.isArray(result.ai_response.suggestions.style.suggestion)
                                            ? (
                                                <ul className="mb-0">
                                                    {result.ai_response.suggestions.style.suggestion.map((item, index) => (
                                                        <li key={index}>{item}</li>
                                                    ))}
                                                </ul>
                                            ) : (
                                                <p className="mb-0">{result.ai_response.suggestions.style.suggestion}</p>
                                            )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    ) : (
                        <p className="text-secondary fs-5">{t("Click 'Scan CV'")}</p>
                    )}
                </div>
            </div>
        </>
    );
}

export default CanCVManagerPage;
